/**
 * Asks omnium once, on start, whether a sign-in is needed.
 *
 * When sign-in is required and nobody is signed in, the person goes to /login
 * and comes back here afterwards. When it is not required — the default — the
 * panel opens as it always has. When omnium does not answer, the panel opens
 * too, so each page can show its own error.
 */

import { useEffect } from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";

import { checkSignIn, gateFor } from "@/lib/api/auth";
import { useAuth } from "@/spa/useAuth";

export function RequireSignIn() {
  const auth = useAuth();
  const location = useLocation();

  useEffect(() => {
    if (auth.status === "checking") void checkSignIn();
  }, [auth.status]);

  const gate = gateFor(auth);
  if (gate === "wait") {
    return (
      <p role="status" style={{ padding: "var(--s6)", color: "var(--ink-3)" }}>
        Opening omnium…
      </p>
    );
  }
  if (gate === "sign_in") {
    const next = encodeURIComponent(`${location.pathname}${location.search}`);
    return <Navigate to={`/login?next=${next}`} replace />;
  }
  return <Outlet />;
}
